import React, { FC } from 'react';
import { Alert } from '@retail-core/rds';
import './NoSizeChartGroupRow.less';

interface Props {
  groupName: string;
  brandName: string;
  cg12Label: string;
}

export const NoSizeChartGroupRow: FC<Props> = ({ groupName, brandName, cg12Label }) => (
  <div className="no-size-chart-group-row">
    <div className="no-size-chart-group-name">{groupName}</div>
    <Alert
      type="warning"
      showIcon
      message={
        <>
          No size chart has been created or linked yet for {brandName}/{cg12Label}. Create a new or link existing size
          chart through{' '}
          <a
            href="https://sites.google.com/a/zalando.de/sizing-business-integration/size-charts"
            target="_blank"
            rel="noreferrer"
          >
            sizing JIRA Tickets
          </a>
          .
        </>
      }
    />
  </div>
);
